import React, { useState } from "react";
import Modal from "react-modal";
import Mcxlist from "./watchlist/Mcxlist";
import Nsclist from "./watchlist/Nsclist";
import { Link } from "react-router-dom";

// Styles for the modal
const customStyles = {
  content: {},
};

// Set the root element for the modal
Modal.setAppElement("#root");
// Component
const Popup = () => {
  const [isOpen, setIsOpen] = useState(true);
  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  return (
    <>
      <Modal isOpen={isOpen} onRequestClose={closeModal} style={customStyles}>
        <div className="module-content">
          <h4>Are you confirm?</h4>
          <p>
            Are you surely to close the <br />
            application
          </p>
          <div style={{ display: "flex" }}>
            <button onClick={closeModal}>DECILNE</button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Popup;
